module.exports = __webpack_public_path__ + "static/media/icon-subtraction.17fa3f71.svg";